export const LANGUAGES = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "es", label: "ES", name: "Español" },
  { code: "it", label: "IT", name: "Italiano" },
  { code: "nl", label: "NL", name: "Nederlands" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "uk", label: "UK", name: "Українська" },
];

const kitchen = {
  fr: "Kitchenette équipée (plaque, micro-ondes, réfrigérateur, lave-vaisselles, toaster, appareil à raclette / gaufre / fondue, bouilloire, machine à café)",
  en: "Equipped kitchenette (hob, microwave, fridge, dishwasher, toaster, raclette / waffle / fondue sets, kettle, coffee machine)",
  de: "Ausgestattete Küchenzeile (Kochfeld, Mikrowelle, Kühlschrank, Geschirrspüler, Toaster, Raclette-/Waffel-/Fonduegerät, Wasserkocher, Kaffeemaschine)",
  es: "Cocina equipada (placa, microondas, nevera, lavavajillas, tostadora, aparato de raclette / gofres / fondue, hervidor, cafetera)",
  it: "Angolo cottura attrezzato (piastra, microonde, frigorifero, lavastoviglie, tostapane, apparecchi per raclette / waffle / fonduta, bollitore, macchina del caffè)",
  ru: "Оборудованная кухня (плита, микроволновая печь, холодильник, посудомоечная машина, тостер, приборы для раклета / вафель / фондю, чайник, кофемашина)",
  uk: "Обладнана кухня (плита, мікрохвильова піч, холодильник, посудомийна машина, тостер, прилади для раклету / вафель / фондю, чайник, кавомашина)",
  nl: "Uitgeruste kitchenette (kookplaat, magnetron, koelkast, vaatwasser, broodrooster, raclette-/wafel-/fonduetoestel, waterkoker, koffiezetapparaat)",
};

export const T = {
  fr: {
    nav: { home: "Accueil", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Demande de renseignement" },
    hero: {
      overline: "Vaucopin — Location de studios — Le Pleynet, Isère",
      line1: "Les 7 Laux,",
      line2a: "l'appel",
      line2b: " des sommets.",
      intro: "Deux studios d'exception au pied des pistes du Pleynet. Le Studio des Ô Glaciers et le Studio des Ô Gentianes vous attendent, été comme hiver.",
      ctaStudios: "Découvrir les studios",
      ctaContact: "Demande de renseignement",
    },
    marquee: ["Ski aux pieds", "Vue panoramique sur Belledonne", "Exposition plein sud", "Station familiale des 7 Laux", "135 km de pistes", "Été : randonnées & lacs d'altitude"],
    studios: { overline: "Nos studios — Le Pleynet", title1: "Deux refuges, ", title2a: "une même exigence", discover: "Découvrir" },
    manifesto: {
      overline: "Le manifeste Vaucopin",
      chapters: [
        { title: "L'Expérience", text: "Le Pleynet, c'est 1 450 mètres d'altitude, un front de neige face au massif de Belledonne et 135 kilomètres de pistes reliées à Prapoutel et Pipay. L'hiver, on chausse les skis au pied de la résidence. L'été, les sentiers de randonnée et les lacs d'altitude s'ouvrent à quelques pas." },
        { title: "Le Confort", text: "Chaque studio a été pensé comme un refuge : matériaux naturels, bois clair, linge de qualité et équipements complets. Kitchenette équipée, casier à skis privatif et parking gratuit — tout est prévu pour que vous n'ayez qu'une chose à faire : profiter." },
        { title: "L'Accueil", text: "SAS Vaucopin est une entreprise familiale. Nous connaissons la station par cœur et restons joignables avant, pendant et après votre séjour. Une question sur les pistes, une adresse de restaurant, un horaire de remontée ? Nous sommes là." },
      ],
    },
    reviews: { overline: "Ils ont séjourné chez nous", title1: "Paroles ", title2a: "de voyageurs", sub: "Avis recueillis auprès de nos hôtes, hiver comme été, au Pleynet." },
    president: {
      overline: "Le mot du Président",
      quote: "Chaque studio que nous louons porte notre nom, et donc notre exigence. Nous sélectionnons nos lieux avec soin, nous les équipons comme nous aimerions les trouver, et nous restons disponibles pour chacun de nos hôtes. La qualité n'est pas une promesse : c'est notre quotidien.",
      role: "Président de la SAS Vaucopin",
    },
    airbnb: {
      overline: "Réservation en ligne",
      title: "Réservez directement sur Airbnb",
      sub: "Retrouvez nos deux studios sur Airbnb : disponibilités en temps réel et réservation sécurisée.",
    },
    seo: {
      home: { title: "Location de studios aux 7 Laux – Le Pleynet | SAS Vaucopin", description: "Deux studios skis aux pieds au Pleynet (Les 7 Laux) : Studio des Ô Glaciers et Ô Gentianes. Tarifs dès 400 € la semaine. Réservation directe ou Airbnb." },
      glaciers: { title: "Studio des Ô Glaciers – Location Le Pleynet | SAS Vaucopin", description: "Studio des Ô Glaciers au Pleynet (5e étage, 28 m², 2 à 4 pers.) : vue Belledonne, kitchenette équipée, parking gratuit. Dès 700 €/semaine en haute saison." },
      gentianes: { title: "Studio des Ô Gentianes – Location Le Pleynet | SAS Vaucopin", description: "Studio des Ô Gentianes au Pleynet (1er étage, 26 m², 2 à 4 pers.) : esprit chalet, vue forêt, kitchenette équipée, parking gratuit. Dès 700 €/semaine." },
      contact: { title: "Demande de renseignement – Studios Les 7 Laux | SAS Vaucopin", description: "Envoyez votre demande de renseignement pour les studios Ô Glaciers et Ô Gentianes au Pleynet. Réponse sous 24 à 48 h. Tél. +33 (0)6 42 42 42 07." },
      legal: { title: "Mentions légales | SAS Vaucopin", description: "Mentions légales du site SAS Vaucopin : siège social, SIREN 914 124 011, contact et données personnelles (RGPD : privacy@vaucopin.com)." },
      privacy: { title: "Politique de confidentialité | SAS Vaucopin", description: "Politique de confidentialité du site SAS Vaucopin : données collectées, finalités, durées de conservation et vos droits RGPD (contact : privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Votre prochain séjour",
      title1: "Réservez votre échappée",
      title2a: " aux 7 Laux",
      contact: "Contact",
      ourStudios: "Nos studios",
      info: "Informations",
      legal: "Mentions légales",
      contactLink: "Demande de renseignement",
      privacyPolicy: "Politique de confidentialité",
    },
    studio: {
      back: "Retour à l'accueil",
      theStudio: "Le studio",
      capacity: "Capacité",
      surface: "Surface",
      location: "Situation",
      orientation: "Exposition",
      amenitiesTitle: "Équipements",
      gallery: "Galerie",
      pricingOverline: "Tarifs indicatifs",
      pricingTitle1: "Des séjours ",
      pricingTitle2a: "à la carte",
      pricingNote: "Tarifs à titre indicatif, à partir de. Pour une cotation précise selon vos dates, envoyez-nous une demande de renseignement ou appelez-nous au {phone}.",
      season: "Saison — prix à partir de",
      week: "Semaine",
      weekend: "Week-end",
      ctaQuote: "Demander un devis pour ce studio",
      ctaAirbnb: "Réserver sur Airbnb",
      seasons: ["Haute saison (vacances scolaires d'hiver)", "Moyenne saison", "Basse saison / été"],
    },
    studioData: {
      glaciers: {
        tagline: "Face aux sommets, baigné de lumière",
        description: "Orienté plein sud, le Studio des Ô Glaciers ouvre sur un panorama exceptionnel de la chaîne de Belledonne. Son séjour tout de bois clair et sa kitchenette entièrement équipée composent un refuge douillet après une journée sur les pistes des 7 Laux. Le soir venu, la grande table familiale accueille les dîners savoyards dans une atmosphère chaleureuse.",
        capacity: "2 à 4 personnes",
        floor: "5e étage avec ascenseur",
        orientation: "Plein sud, vue sur la chaîne de Belledonne",
        amenities: [kitchen.fr, "Coin repas familial avec grande table", "Couchages : canapé convertible + couchages d'appoint", "TV écran plat", "Casier à skis privatif au pied des pistes", "Parking gratuit"],
      },
      gentianes: {
        tagline: "L'esprit chalet, au cœur de la station",
        description: "Le Studio des Ô Gentianes cultive l'esprit chalet authentique : mobilier de caractère, touches de couleur inspirées des gentianes alpines et une fenêtre ouverte sur les sapins et les crêtes. Idéalement placé au cœur du Pleynet, il permet de chausser les skis au pied de la résidence et de rejoindre commerces et restaurants en quelques pas.",
        capacity: "2 à 4 personnes",
        floor: "1er étage avec ascenseur",
        orientation: "Vue sur la forêt et les sommets",
        amenities: ["Coin repas convivial pour 4 personnes", kitchen.fr, "Couchages : canapé-lit + coin montagne", "TV écran plat", "Casier à skis privatif au pied des pistes", "Parking gratuit"],
      },
    },
    contact: {
      overline: "Demande de renseignement",
      line1: "Parlez-nous de",
      line2a: "votre séjour.",
      name: "Nom complet *",
      namePh: "Jean Dupont",
      email: "Email *",
      emailPh: "jean@exemple.fr",
      phone: "Téléphone",
      phonePh: "06 00 00 00 00",
      studioLabel: "Studio concerné",
      both: "Les deux studios",
      arrival: "Date d'arrivée souhaitée",
      departure: "Date de départ souhaitée",
      message: "Votre message *",
      messagePh: "Bonjour, nous souhaiterions connaître les disponibilités pour...",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours...",
      privacyNote: "Vos données sont utilisées uniquement pour traiter votre demande. Contact RGPD : {privacy}",
      directTitle: "Contact direct",
      directNote: "Nous répondons à toutes les demandes sous 24 à 48 heures. Pour les réservations de dernière minute, privilégiez le téléphone.",
      errName: "Veuillez indiquer votre nom.",
      errEmail: "Veuillez indiquer un email valide.",
      errMessage: "Votre message est un peu court (10 caractères minimum).",
      success: "Votre demande a bien été envoyée. Nous vous répondrons rapidement.",
      error: "Une erreur est survenue. Réessayez ou contactez-nous directement par téléphone.",
    },
  },

  en: {
    nav: { home: "Home", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Enquiry" },
    hero: {
      overline: "Vaucopin — Studio rentals — Le Pleynet, Isère",
      line1: "Les 7 Laux,",
      line2a: "the call",
      line2b: " of the peaks.",
      intro: "Two exceptional studios at the foot of the slopes in Le Pleynet. The Studio des Ô Glaciers and the Studio des Ô Gentianes await you, summer and winter.",
      ctaStudios: "Discover the studios",
      ctaContact: "Enquiry",
    },
    marquee: ["Ski-in ski-out", "Panoramic view over Belledonne", "South-facing", "Family resort Les 7 Laux", "135 km of slopes", "Summer: hiking & alpine lakes"],
    studios: { overline: "Our studios — Le Pleynet", title1: "Two retreats, ", title2a: "one shared standard", discover: "Discover" },
    manifesto: {
      overline: "The Vaucopin manifesto",
      chapters: [
        { title: "The Experience", text: "Le Pleynet sits at 1,450 metres, facing the Belledonne massif, with 135 kilometres of slopes linked to Prapoutel and Pipay. In winter, you clip into your skis at the foot of the residence. In summer, hiking trails and alpine lakes start just steps away." },
        { title: "The Comfort", text: "Each studio is designed as a retreat: natural materials, light wood, quality linen and full equipment. Fitted kitchenette, private ski locker and free parking — everything is planned so you have only one thing to do: enjoy." },
        { title: "The Welcome", text: "SAS Vaucopin is a family business. We know the resort by heart and remain reachable before, during and after your stay. A question about the slopes, a restaurant address, a lift schedule? We are here." },
      ],
    },
    reviews: { overline: "They stayed with us", title1: "Words from ", title2a: "our guests", sub: "Reviews collected from our guests, winter and summer, in Le Pleynet." },
    president: {
      overline: "A word from the President",
      quote: "Every studio we rent carries our name, and therefore our standards. We select our locations with care, we equip them as we would like to find them ourselves, and we remain available to every one of our guests. Quality is not a promise: it is our daily practice.",
      role: "President of SAS Vaucopin",
    },
    airbnb: {
      overline: "Book online",
      title: "Book directly on Airbnb",
      sub: "Find our two studios on Airbnb: real-time availability and secure booking.",
    },
    seo: {
      home: { title: "Ski Studio Rentals Les 7 Laux – Le Pleynet | Vaucopin", description: "Two ski-in ski-out studios in Le Pleynet (Les 7 Laux): Studio des Ô Glaciers & Ô Gentianes. Weekly rates from €400. Book direct or on Airbnb." },
      glaciers: { title: "Studio des Ô Glaciers – Le Pleynet Rental | Vaucopin", description: "Studio des Ô Glaciers in Le Pleynet (5th floor, 28 m², 2–4 guests): Belledonne views, equipped kitchenette, free parking. From €700/week in high season." },
      gentianes: { title: "Studio des Ô Gentianes – Le Pleynet Rental | Vaucopin", description: "Studio des Ô Gentianes in Le Pleynet (1st floor, 26 m², 2–4 guests): chalet style, forest views, equipped kitchenette, free parking. From €700/week." },
      contact: { title: "Enquiry – Les 7 Laux Studios | Vaucopin", description: "Send your enquiry for the Ô Glaciers and Ô Gentianes studios in Le Pleynet. Reply within 24–48 h. Tel. +33 (0)6 42 42 42 07." },
      legal: { title: "Legal notice | SAS Vaucopin", description: "Legal notice of the SAS Vaucopin website: registered office, SIREN 914 124 011, contact and personal data (GDPR: privacy@vaucopin.com)." },
      privacy: { title: "Privacy policy | SAS Vaucopin", description: "Privacy policy of the SAS Vaucopin website: data collected, purposes, retention periods and your GDPR rights (contact: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Your next stay",
      title1: "Book your escape",
      title2a: " to Les 7 Laux",
      contact: "Contact",
      ourStudios: "Our studios",
      info: "Information",
      legal: "Legal notice",
      contactLink: "Enquiry",
      privacyPolicy: "Privacy policy",
    },
    studio: {
      back: "Back to home",
      theStudio: "The studio",
      capacity: "Capacity",
      surface: "Surface",
      location: "Location",
      orientation: "Aspect",
      amenitiesTitle: "Amenities",
      gallery: "Gallery",
      pricingOverline: "Indicative rates",
      pricingTitle1: "Stays ",
      pricingTitle2a: "à la carte",
      pricingNote: "Indicative rates, from. For a precise quote for your dates, send us an enquiry or call us on {phone}.",
      season: "Season — prices from",
      week: "Week",
      weekend: "Weekend",
      ctaQuote: "Request a quote for this studio",
      ctaAirbnb: "Book on Airbnb",
      seasons: ["High season (winter school holidays)", "Mid season", "Low season / summer"],
    },
    studioData: {
      glaciers: {
        tagline: "Facing the peaks, bathed in light",
        description: "Facing south, the Studio des Ô Glaciers opens onto an exceptional panorama of the Belledonne range. Its light-wood living area and fully equipped kitchenette make a cosy retreat after a day on the slopes of Les 7 Laux. In the evening, the large family table hosts Savoyard dinners in a warm atmosphere.",
        capacity: "2 to 4 people",
        floor: "5th floor with lift",
        orientation: "South-facing, view over the Belledonne range",
        amenities: [kitchen.en, "Family dining area with large table", "Sleeping: sofa bed + extra beds", "Flat-screen TV", "Private ski locker at the foot of the slopes", "Free parking"],
      },
      gentianes: {
        tagline: "Chalet spirit, in the heart of the resort",
        description: "The Studio des Ô Gentianes cultivates an authentic chalet spirit: character furniture, touches of colour inspired by alpine gentians and a window opening onto firs and ridges. Ideally located in the heart of Le Pleynet, you can clip into your skis at the foot of the residence and reach shops and restaurants in a few steps.",
        capacity: "2 to 4 people",
        floor: "1st floor with lift",
        orientation: "Forest and peak views",
        amenities: ["Cosy dining area for 4 people", kitchen.en, "Sleeping: sofa bed + mountain corner bunks", "Flat-screen TV", "Private ski locker at the foot of the slopes", "Free parking"],
      },
    },
    contact: {
      overline: "Enquiry",
      line1: "Tell us about",
      line2a: "your stay.",
      name: "Full name *",
      namePh: "John Smith",
      email: "Email *",
      emailPh: "john@example.com",
      phone: "Phone",
      phonePh: "+44 7000 000000",
      studioLabel: "Studio concerned",
      both: "Both studios",
      arrival: "Preferred arrival date",
      departure: "Preferred departure date",
      message: "Your message *",
      messagePh: "Hello, we would like to know the availability for...",
      submit: "Send my enquiry",
      sending: "Sending...",
      privacyNote: "Your data is used only to process your enquiry. GDPR contact: {privacy}",
      directTitle: "Direct contact",
      directNote: "We answer all enquiries within 24 to 48 hours. For last-minute bookings, please call us.",
      errName: "Please enter your name.",
      errEmail: "Please enter a valid email address.",
      errMessage: "Your message is a bit short (10 characters minimum).",
      success: "Your enquiry has been sent. We will reply shortly.",
      error: "Something went wrong. Please try again or call us directly.",
    },
  },

  de: {
    nav: { home: "Start", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Anfrage" },
    hero: {
      overline: "Vaucopin — Studiovermietung — Le Pleynet, Isère",
      line1: "Les 7 Laux,",
      line2a: "der Ruf",
      line2b: " der Gipfel.",
      intro: "Zwei außergewöhnliche Studios am Fuß der Pisten von Le Pleynet. Das Studio des Ô Glaciers und das Studio des Ô Gentianes erwarten Sie, Sommer wie Winter.",
      ctaStudios: "Studios entdecken",
      ctaContact: "Anfrage",
    },
    marquee: ["Ski direkt vor der Tür", "Panoramablick auf Belledonne", "Südlage", "Familienskigebiet Les 7 Laux", "135 km Pisten", "Sommer: Wandern & Bergseen"],
    studios: { overline: "Unsere Studios — Le Pleynet", title1: "Zwei Rückzugsorte, ", title2a: "ein Anspruch", discover: "Entdecken" },
    manifesto: {
      overline: "Das Vaucopin-Manifest",
      chapters: [
        { title: "Das Erlebnis", text: "Le Pleynet liegt auf 1.450 Metern, mit Blick auf das Belledonne-Massiv und 135 Pistenkilometern, verbunden mit Prapoutel und Pipay. Im Winter schnallen Sie die Skier direkt am Haus an. Im Sommer beginnen Wanderwege und Bergseen nur wenige Schritte entfernt." },
        { title: "Der Komfort", text: "Jedes Studio ist als Rückzugsort gedacht: natürliche Materialien, helles Holz, hochwertige Bettwäsche und vollständige Ausstattung. Ausgestattete Küchenzeile, privater Skiraum und kostenloser Parkplatz — alles ist vorbereitet, damit Sie nur eines tun müssen: genießen." },
        { title: "Der Empfang", text: "Die SAS Vaucopin ist ein Familienunternehmen. Wir kennen die Station auswendig und sind vor, während und nach Ihrem Aufenthalt erreichbar. Eine Frage zu den Pisten, eine Restaurantadresse, eine Liftzeit? Wir sind da." },
      ],
    },
    reviews: { overline: "Unsere Gäste", title1: "Stimmen ", title2a: "unserer Gäste", sub: "Bewertungen unserer Gäste, Winter wie Sommer, in Le Pleynet." },
    president: {
      overline: "Ein Wort des Präsidenten",
      quote: "Jedes Studio, das wir vermieten, trägt unseren Namen — und damit unseren Anspruch. Wir wählen unsere Orte mit Sorgfalt aus, rüsten sie so aus, wie wir sie selbst vorfinden möchten, und bleiben für jeden unserer Gäste erreichbar. Qualität ist kein Versprechen: Sie ist unser Alltag.",
      role: "Präsident der SAS Vaucopin",
    },
    airbnb: {
      overline: "Online buchen",
      title: "Direkt auf Airbnb buchen",
      sub: "Unsere beiden Studios auf Airbnb: Verfügbarkeit in Echtzeit und sichere Buchung.",
    },
    seo: {
      home: { title: "Ski-Studios Les 7 Laux – Le Pleynet | Vaucopin", description: "Zwei Studios direkt an der Piste in Le Pleynet (Les 7 Laux): Studio des Ô Glaciers & Ô Gentianes. Wochenpreise ab 400 €. Direkt oder über Airbnb buchen." },
      glaciers: { title: "Studio des Ô Glaciers – Le Pleynet | Vaucopin", description: "Studio des Ô Glaciers in Le Pleynet (5. Etage, 28 m², 2–4 Pers.): Belledonne-Blick, ausgestattete Küchenzeile, kostenloser Parkplatz. Ab 700 €/Woche." },
      gentianes: { title: "Studio des Ô Gentianes – Le Pleynet | Vaucopin", description: "Studio des Ô Gentianes in Le Pleynet (1. Etage, 26 m², 2–4 Pers.): Chalet-Stil, Waldblick, ausgestattete Küchenzeile, kostenloser Parkplatz. Ab 700 €/Woche." },
      contact: { title: "Anfrage – Studios Les 7 Laux | Vaucopin", description: "Senden Sie Ihre Anfrage für die Studios Ô Glaciers und Ô Gentianes in Le Pleynet. Antwort innerhalb von 24–48 h. Tel. +33 (0)6 42 42 42 07." },
      legal: { title: "Impressum | SAS Vaucopin", description: "Impressum der Website der SAS Vaucopin: Sitz, SIREN 914 124 011, Kontakt und personenbezogene Daten (DSGVO: privacy@vaucopin.com)." },
      privacy: { title: "Datenschutzerklärung | SAS Vaucopin", description: "Datenschutzerklärung der SAS Vaucopin-Website: erhobene Daten, Zwecke, Speicherdauer und Ihre DSGVO-Rechte (Kontakt: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Ihr nächster Aufenthalt",
      title1: "Buchen Sie Ihre Auszeit",
      title2a: " in Les 7 Laux",
      contact: "Kontakt",
      ourStudios: "Unsere Studios",
      info: "Informationen",
      legal: "Impressum",
      contactLink: "Anfrage",
      privacyPolicy: "Datenschutzerklärung",
    },
    studio: {
      back: "Zurück zur Startseite",
      theStudio: "Das Studio",
      capacity: "Kapazität",
      surface: "Fläche",
      location: "Lage",
      orientation: "Ausrichtung",
      amenitiesTitle: "Ausstattung",
      gallery: "Galerie",
      pricingOverline: "Richtpreise",
      pricingTitle1: "Aufenthalte ",
      pricingTitle2a: "nach Wunsch",
      pricingNote: "Richtpreise, ab. Für ein genaues Angebot zu Ihren Daten senden Sie uns eine Anfrage oder rufen Sie uns an: {phone}.",
      season: "Saison — Preise ab",
      week: "Woche",
      weekend: "Wochenende",
      ctaQuote: "Angebot für dieses Studio anfragen",
      ctaAirbnb: "Auf Airbnb buchen",
      seasons: ["Hochsaison (Winter-Schulferien)", "Zwischensaison", "Nebensaison / Sommer"],
    },
    studioData: {
      glaciers: {
        tagline: "Den Gipfeln zugewandt, lichtdurchflutet",
        description: "Nach Süden ausgerichtet, öffnet sich das Studio des Ô Glaciers auf ein außergewöhnliches Panorama der Belledonne-Kette. Der Wohnbereich aus hellem Holz und die voll ausgestattete Küchenzeile bilden einen gemütlichen Rückzugsort nach einem Tag auf den Pisten von Les 7 Laux. Am Abend lädt der große Familientisch zu herzhaften Savoyer Abendessen ein.",
        capacity: "2 bis 4 Personen",
        floor: "5. Etage mit Aufzug",
        orientation: "Nach Süden, Blick auf die Belledonne-Kette",
        amenities: [kitchen.de, "Familiärer Essbereich mit großem Tisch", "Schlafplätze: Schlafsofa + Zusatzliegen", "Flachbildfernseher", "Privates Skidepot am Fuß der Pisten", "Kostenloser Parkplatz"],
      },
      gentianes: {
        tagline: "Chalet-Flair im Herzen der Station",
        description: "Das Studio des Ô Gentianes pflegt den authentischen Chaletgeist: Möbel mit Charakter, Farbakzente inspiriert von den Alpen-Enzianen und ein Fenster mit Blick auf Tannen und Grate. Ideal im Herzen von Le Pleynet gelegen, schnallen Sie die Skier direkt am Haus an und erreichen Geschäfte und Restaurants in wenigen Schritten.",
        capacity: "2 bis 4 Personen",
        floor: "1. Etage mit Aufzug",
        orientation: "Blick auf Wald und Gipfel",
        amenities: ["Gemütlicher Essbereich für 4 Personen", kitchen.de, "Schlafplätze: Schlafsofa + Berg-Etagenbetten", "Flachbildfernseher", "Privates Skidepot am Fuß der Pisten", "Kostenloser Parkplatz"],
      },
    },
    contact: {
      overline: "Anfrage",
      line1: "Erzählen Sie uns von",
      line2a: "Ihrem Aufenthalt.",
      name: "Vollständiger Name *",
      namePh: "Max Mustermann",
      email: "E-Mail *",
      emailPh: "max@beispiel.de",
      phone: "Telefon",
      phonePh: "+49 170 0000000",
      studioLabel: "Betreffendes Studio",
      both: "Beide Studios",
      arrival: "Gewünschtes Anreisedatum",
      departure: "Gewünschtes Abreisedatum",
      message: "Ihre Nachricht *",
      messagePh: "Guten Tag, wir möchten die Verfügbarkeit anfragen für...",
      submit: "Anfrage senden",
      sending: "Wird gesendet...",
      privacyNote: "Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet. DSGVO-Kontakt: {privacy}",
      directTitle: "Direkter Kontakt",
      directNote: "Wir beantworten alle Anfragen innerhalb von 24 bis 48 Stunden. Für Last-Minute-Buchungen rufen Sie uns bitte an.",
      errName: "Bitte geben Sie Ihren Namen ein.",
      errEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      errMessage: "Ihre Nachricht ist etwas kurz (mindestens 10 Zeichen).",
      success: "Ihre Anfrage wurde gesendet. Wir antworten Ihnen in Kürze.",
      error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder rufen Sie uns direkt an.",
    },
  },

  es: {
    nav: { home: "Inicio", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Información" },
    hero: {
      overline: "Vaucopin — Alquiler de estudios — Le Pleynet, Isère",
      line1: "Les 7 Laux,",
      line2a: "la llamada",
      line2b: " de las cumbres.",
      intro: "Dos estudios excepcionales al pie de las pistas de Le Pleynet. El Studio des Ô Glaciers y el Studio des Ô Gentianes les esperan, en verano y en invierno.",
      ctaStudios: "Descubrir los estudios",
      ctaContact: "Solicitud de información",
    },
    marquee: ["Esquí a los pies", "Vista panorámica de Belledonne", "Orientación sur", "Estación familiar Les 7 Laux", "135 km de pistas", "Verano: senderismo y lagos de altura"],
    studios: { overline: "Nuestros estudios — Le Pleynet", title1: "Dos refugios, ", title2a: "una misma exigencia", discover: "Descubrir" },
    manifesto: {
      overline: "El manifiesto Vaucopin",
      chapters: [
        { title: "La Experiencia", text: "Le Pleynet está a 1.450 metros de altitud, frente al macizo de Belledonne, con 135 kilómetros de pistas conectadas con Prapoutel y Pipay. En invierno, se calzan los esquís al pie de la residencia. En verano, las rutas de senderismo y los lagos alpinos empiezan a pocos pasos." },
        { title: "El Confort", text: "Cada estudio está pensado como un refugio: materiales naturales, madera clara, ropa de cama de calidad y equipamiento completo. Cocina equipada, guardaesquís privado y parking gratuito: todo está previsto para que solo tenga una cosa que hacer: disfrutar." },
        { title: "La Acogida", text: "SAS Vaucopin es una empresa familiar. Conocemos la estación de memoria y seguimos disponibles antes, durante y después de su estancia. ¿Una pregunta sobre las pistas, un restaurante, un horario de remontes? Estamos aquí." },
      ],
    },
    reviews: { overline: "Se alojaron con nosotros", title1: "Palabras ", title2a: "de viajeros", sub: "Opiniones recogidas entre nuestros huéspedes, en invierno y en verano, en Le Pleynet." },
    president: {
      overline: "Palabras del Presidente",
      quote: "Cada estudio que alquilamos lleva nuestro nombre y, por tanto, nuestra exigencia. Seleccionamos nuestros lugares con cuidado, los equipamos como nos gustaría encontrarlos y permanecemos disponibles para cada uno de nuestros huéspedes. La calidad no es una promesa: es nuestro día a día.",
      role: "Presidente de SAS Vaucopin",
    },
    airbnb: {
      overline: "Reserva en línea",
      title: "Reserve directamente en Airbnb",
      sub: "Encuentre nuestros dos estudios en Airbnb: disponibilidad en tiempo real y reserva segura.",
    },
    seo: {
      home: { title: "Alquiler de estudios Les 7 Laux – Le Pleynet | Vaucopin", description: "Dos estudios a pie de pistas en Le Pleynet (Les 7 Laux): Studio des Ô Glaciers y Ô Gentianes. Tarifas desde 400 €/semana. Directo o por Airbnb." },
      glaciers: { title: "Studio des Ô Glaciers – Le Pleynet | Vaucopin", description: "Studio des Ô Glaciers en Le Pleynet (5.ª planta, 28 m², 2–4 pers.): vistas a Belledonne, cocina equipada, parking gratuito. Desde 700 €/semana." },
      gentianes: { title: "Studio des Ô Gentianes – Le Pleynet | Vaucopin", description: "Studio des Ô Gentianes en Le Pleynet (1.ª planta, 26 m², 2–4 pers.): estilo chalé, vistas al bosque, cocina equipada, parking gratuito. Desde 700 €/semana." },
      contact: { title: "Información – Estudios Les 7 Laux | Vaucopin", description: "Envíe su solicitud para los estudios Ô Glaciers y Ô Gentianes en Le Pleynet. Respuesta en 24-48 h. Tel. +33 (0)6 42 42 42 07." },
      legal: { title: "Aviso legal | SAS Vaucopin", description: "Aviso legal del sitio web de SAS Vaucopin: sede social, SIREN 914 124 011, contacto y datos personales (RGPD: privacy@vaucopin.com)." },
      privacy: { title: "Política de privacidad | SAS Vaucopin", description: "Política de privacidad del sitio SAS Vaucopin: datos recogidos, finalidades, plazos de conservación y sus derechos RGPD (contacto: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Su próxima estancia",
      title1: "Reserve su escapada",
      title2a: " a Les 7 Laux",
      contact: "Contacto",
      ourStudios: "Nuestros estudios",
      info: "Información",
      legal: "Aviso legal",
      contactLink: "Solicitud de información",
      privacyPolicy: "Política de privacidad",
    },
    studio: {
      back: "Volver al inicio",
      theStudio: "El estudio",
      capacity: "Capacidad",
      surface: "Superficie",
      location: "Situación",
      orientation: "Orientación",
      amenitiesTitle: "Equipamiento",
      gallery: "Galería",
      pricingOverline: "Tarifas orientativas",
      pricingTitle1: "Estancias ",
      pricingTitle2a: "a la carta",
      pricingNote: "Tarifas orientativas, desde. Para un presupuesto preciso según sus fechas, envíenos una solicitud o llámenos al {phone}.",
      season: "Temporada — precios desde",
      week: "Semana",
      weekend: "Fin de semana",
      ctaQuote: "Solicitar presupuesto para este estudio",
      ctaAirbnb: "Reservar en Airbnb",
      seasons: ["Temporada alta (vacaciones escolares de invierno)", "Temporada media", "Temporada baja / verano"],
    },
    studioData: {
      glaciers: {
        tagline: "Frente a las cumbres, bañado de luz",
        description: "Orientado al sur, el Studio des Ô Glaciers se abre a un panorama excepcional de la cadena de Belledonne. Su salón de madera clara y su cocina totalmente equipada forman un refugio acogedor tras un día en las pistas de Les 7 Laux. Por la noche, la gran mesa familiar acoge cenas saboyardas en un ambiente cálido.",
        capacity: "2 a 4 personas",
        floor: "5.ª planta con ascensor",
        orientation: "Al sur, vistas a la cadena de Belledonne",
        amenities: [kitchen.es, "Zona de comedor familiar con gran mesa", "Camas: sofá cama + camas supletorias", "TV de pantalla plana", "Guardaesquís privado al pie de las pistas", "Parking gratuito"],
      },
      gentianes: {
        tagline: "Espíritu de chalé en el corazón de la estación",
        description: "El Studio des Ô Gentianes cultiva el auténtico espíritu de chalé: muebles con carácter, toques de color inspirados en las gencianas alpinas y una ventana abierta a los abetos y las crestas. Idealmente situado en el corazón de Le Pleynet, permite calzar los esquís al pie de la residencia y llegar a tiendas y restaurantes en pocos pasos.",
        capacity: "2 a 4 personas",
        floor: "1.ª planta con ascensor",
        orientation: "Vistas al bosque y las cumbres",
        amenities: ["Comedor acogedor para 4 personas", kitchen.es, "Camas: sofá cama + rincón montaña", "TV de pantalla plana", "Guardaesquís privado al pie de las pistas", "Parking gratuito"],
      },
    },
    contact: {
      overline: "Solicitud de información",
      line1: "Cuéntenos",
      line2a: "su estancia.",
      name: "Nombre completo *",
      namePh: "Juan García",
      email: "Email *",
      emailPh: "juan@ejemplo.es",
      phone: "Teléfono",
      phonePh: "+34 600 000 000",
      studioLabel: "Estudio correspondiente",
      both: "Los dos estudios",
      arrival: "Fecha de llegada deseada",
      departure: "Fecha de salida deseada",
      message: "Su mensaje *",
      messagePh: "Hola, nos gustaría conocer la disponibilidad para...",
      submit: "Enviar mi solicitud",
      sending: "Enviando...",
      privacyNote: "Sus datos se utilizan únicamente para tramitar su solicitud. Contacto RGPD: {privacy}",
      directTitle: "Contacto directo",
      directNote: "Respondemos a todas las solicitudes en un plazo de 24 a 48 horas. Para reservas de última hora, llámenos.",
      errName: "Por favor, indique su nombre.",
      errEmail: "Por favor, indique un email válido.",
      errMessage: "Su mensaje es un poco corto (mínimo 10 caracteres).",
      success: "Su solicitud ha sido enviada. Le responderemos pronto.",
      error: "Se ha producido un error. Inténtelo de nuevo o llámenos directamente.",
    },
  },

  it: {
    nav: { home: "Home", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Richiesta" },
    hero: {
      overline: "Vaucopin — Affitto monolocali — Le Pleynet, Isère",
      line1: "Les 7 Laux,",
      line2a: "il richiamo",
      line2b: " delle vette.",
      intro: "Due monolocali d'eccezione ai piedi delle piste di Le Pleynet. Lo Studio des Ô Glaciers e lo Studio des Ô Gentianes vi aspettano, estate e inverno.",
      ctaStudios: "Scopri i monolocali",
      ctaContact: "Richiesta di informazioni",
    },
    marquee: ["Sci ai piedi", "Vista panoramica sulla Belledonne", "Esposizione sud", "Stazione familiare Les 7 Laux", "135 km di piste", "Estate: escursioni e laghi alpini"],
    studios: { overline: "I nostri monolocali — Le Pleynet", title1: "Due rifugi, ", title2a: "una stessa ricerca", discover: "Scoprire" },
    manifesto: {
      overline: "Il manifesto Vaucopin",
      chapters: [
        { title: "L'Esperienza", text: "Le Pleynet si trova a 1.450 metri di quota, di fronte al massiccio della Belledonne, con 135 chilometri di piste collegate a Prapoutel e Pipay. D'inverno si calzano gli sci ai piedi della residenza. D'estate, i sentieri e i laghi alpini partono a pochi passi." },
        { title: "Il Comfort", text: "Ogni monolocale è pensato come un rifugio: materiali naturali, legno chiaro, biancheria di qualità e attrezzatura completa. Angolo cottura attrezzato, deposito sci privato e parcheggio gratuito: tutto è previsto affinché abbiate una sola cosa da fare: godervi la vacanza." },
        { title: "L'Accoglienza", text: "SAS Vaucopin è un'azienda familiare. Conosciamo la stazione a memoria e restiamo raggiungibili prima, durante e dopo il vostro soggiorno. Una domanda sulle piste, un indirizzo di ristorante, un orario degli impianti? Ci siamo." },
      ],
    },
    reviews: { overline: "Hanno soggiornato da noi", title1: "Parole ", title2a: "di viaggiatori", sub: "Recensioni raccolte dai nostri ospiti, inverno ed estate, a Le Pleynet." },
    president: {
      overline: "Una parola del Presidente",
      quote: "Ogni monolocale che affittiamo porta il nostro nome, e quindi la nostra esigenza. Selezioniamo i nostri luoghi con cura, li attrezziamo come vorremmo trovarli e restiamo disponibili per ciascuno dei nostri ospiti. La qualità non è una promessa: è il nostro quotidiano.",
      role: "Presidente della SAS Vaucopin",
    },
    airbnb: {
      overline: "Prenota online",
      title: "Prenotate direttamente su Airbnb",
      sub: "Trovate i nostri due monolocali su Airbnb: disponibilità in tempo reale e prenotazione sicura.",
    },
    seo: {
      home: { title: "Affitto monolocali Les 7 Laux – Le Pleynet | Vaucopin", description: "Due monolocali ai piedi delle piste a Le Pleynet (Les 7 Laux): Studio des Ô Glaciers e Ô Gentianes. Tariffe da 400 €/settimana. Diretto o Airbnb." },
      glaciers: { title: "Studio des Ô Glaciers – Le Pleynet | Vaucopin", description: "Studio des Ô Glaciers a Le Pleynet (5º piano, 28 m², 2–4 pers.): vista Belledonne, angolo cottura attrezzato, parcheggio gratuito. Da 700 €/settimana." },
      gentianes: { title: "Studio des Ô Gentianes – Le Pleynet | Vaucopin", description: "Studio des Ô Gentianes a Le Pleynet (1º piano, 26 m², 2–4 pers.): stile chalet, vista bosco, angolo cottura attrezzato, parcheggio gratuito. Da 700 €/settimana." },
      contact: { title: "Richiesta – Monolocali Les 7 Laux | Vaucopin", description: "Inviate la vostra richiesta per i monolocali Ô Glaciers e Ô Gentianes a Le Pleynet. Risposta entro 24-48 h. Tel. +33 (0)6 42 42 42 07." },
      legal: { title: "Note legali | SAS Vaucopin", description: "Note legali del sito SAS Vaucopin: sede legale, SIREN 914 124 011, contatti e dati personali (GDPR: privacy@vaucopin.com)." },
      privacy: { title: "Informativa sulla privacy | SAS Vaucopin", description: "Informativa sulla privacy del sito SAS Vaucopin: dati raccolti, finalità, tempi di conservazione e i vostri diritti GDPR (contatto: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Il vostro prossimo soggiorno",
      title1: "Prenotate la vostra fuga",
      title2a: " a Les 7 Laux",
      contact: "Contatti",
      ourStudios: "I nostri monolocali",
      info: "Informazioni",
      legal: "Note legali",
      contactLink: "Richiesta di informazioni",
      privacyPolicy: "Informativa sulla privacy",
    },
    studio: {
      back: "Torna alla home",
      theStudio: "Il monolocale",
      capacity: "Capacità",
      surface: "Superficie",
      location: "Posizione",
      orientation: "Esposizione",
      amenitiesTitle: "Dotazioni",
      gallery: "Galleria",
      pricingOverline: "Tariffe indicative",
      pricingTitle1: "Soggiorni ",
      pricingTitle2a: "su misura",
      pricingNote: "Tariffe indicative, a partire da. Per un preventivo preciso in base alle vostre date, inviateci una richiesta o chiamateci al {phone}.",
      season: "Stagione — prezzi da",
      week: "Settimana",
      weekend: "Weekend",
      ctaQuote: "Richiedi un preventivo per questo monolocale",
      ctaAirbnb: "Prenota su Airbnb",
      seasons: ["Alta stagione (vacanze scolastiche invernali)", "Media stagione", "Bassa stagione / estate"],
    },
    studioData: {
      glaciers: {
        tagline: "Di fronte alle vette, immerso nella luce",
        description: "Esposto a sud, lo Studio des Ô Glaciers si apre su un panorama eccezionale della catena del Belledonne. Il soggiorno in legno chiaro e l'angolo cottura completamente attrezzato compongono un rifugio accogliente dopo una giornata sulle piste di Les 7 Laux. La sera, la grande tavola familiare accoglie cene savoiarde in un'atmosfera calda.",
        capacity: "da 2 a 4 persone",
        floor: "5º piano con ascensore",
        orientation: "A sud, vista sulla catena del Belledonne",
        amenities: [kitchen.it, "Zona pranzo familiare con grande tavolo", "Posti letto: divano letto + letti aggiuntivi", "TV a schermo piatto", "Deposito sci privato ai piedi delle piste", "Parcheggio gratuito"],
      },
      gentianes: {
        tagline: "Spirito chalet nel cuore della stazione",
        description: "Lo Studio des Ô Gentianes coltiva l'autentico spirito chalet: mobili di carattere, tocchi di colore ispirati alle genziane alpine e una finestra aperta su abeti e creste. Idealmente situato nel cuore di Le Pleynet, permette di calzare gli sci ai piedi della residenza e di raggiungere negozi e ristoranti in pochi passi.",
        capacity: "da 2 a 4 persone",
        floor: "1º piano con ascensore",
        orientation: "Vista sul bosco e sulle vette",
        amenities: ["Zona pranzo conviviale per 4 persone", kitchen.it, "Posti letto: divano letto + angolo montagna", "TV a schermo piatto", "Deposito sci privato ai piedi delle piste", "Parcheggio gratuito"],
      },
    },
    contact: {
      overline: "Richiesta di informazioni",
      line1: "Raccontateci",
      line2a: "il vostro soggiorno.",
      name: "Nome completo *",
      namePh: "Mario Rossi",
      email: "Email *",
      emailPh: "mario@esempio.it",
      phone: "Telefono",
      phonePh: "+39 300 000 0000",
      studioLabel: "Monolocale interessato",
      both: "Entrambi i monolocali",
      arrival: "Data di arrivo desiderata",
      departure: "Data di partenza desiderata",
      message: "Il vostro messaggio *",
      messagePh: "Buongiorno, vorremmo conoscere la disponibilità per...",
      submit: "Invia la richiesta",
      sending: "Invio in corso...",
      privacyNote: "I vostri dati sono utilizzati solo per gestire la richiesta. Contatto GDPR: {privacy}",
      directTitle: "Contatto diretto",
      directNote: "Rispondiamo a tutte le richieste entro 24-48 ore. Per prenotazioni last minute, chiamateci.",
      errName: "Inserite il vostro nome.",
      errEmail: "Inserite un'email valida.",
      errMessage: "Il messaggio è un po' corto (minimo 10 caratteri).",
      success: "La richiesta è stata inviata. Vi risponderemo presto.",
      error: "Si è verificato un errore. Riprovate o chiamateci direttamente.",
    },
  },

  ru: {
    nav: { home: "Главная", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Запрос" },
    hero: {
      overline: "Vaucopin — Аренда студий — Ле-Плене, Изер",
      line1: "Ле-7-Ло,",
      line2a: "зов",
      line2b: " вершин.",
      intro: "Две исключительные студии у подножия трасс Ле-Плене. Студия Ô Glaciers и студия Ô Gentianes ждут вас летом и зимой.",
      ctaStudios: "Смотреть студии",
      ctaContact: "Запрос информации",
    },
    marquee: ["Лыжи у порога", "Панорамный вид на Беледонн", "Южная сторона", "Семейный курорт Ле-7-Ло", "135 км трасс", "Лето: походы и горные озёра"],
    studios: { overline: "Наши студии — Ле-Плене", title1: "Два убежища, ", title2a: "один стандарт", discover: "Подробнее" },
    manifesto: {
      overline: "Манифест Vaucopin",
      chapters: [
        { title: "Впечатления", text: "Ле-Плене расположен на высоте 1450 метров, напротив массива Беледонн, со 135 километрами трасс, соединённых с Прапутелем и Пипе. Зимой лыжи надеваются прямо у резиденции. Летом пешие маршруты и горные озёра начинаются в нескольких шагах." },
        { title: "Комфорт", text: "Каждая студия задумана как убежище: натуральные материалы, светлое дерево, качественное бельё и полное оснащение. Оборудованная кухня, личная лыжная ячейка и бесплатная парковка — всё предусмотрено, чтобы вам осталось одно: наслаждаться." },
        { title: "Гостеприимство", text: "SAS Vaucopin — семейная компания. Мы знаем курорт наизусть и остаёмся на связи до, во время и после вашего отдыха. Вопрос о трассах, адрес ресторана, расписание подъёмников? Мы рядом." },
      ],
    },
    reviews: { overline: "Они останавливались у нас", title1: "Слова ", title2a: "путешественников", sub: "Отзывы наших гостей, зимой и летом, в Ле-Плене." },
    president: {
      overline: "Слово Президента",
      quote: "Каждая студия, которую мы сдаём, несёт наше имя — а значит, и наши стандарты. Мы тщательно выбираем места, оборудуем их так, как хотели бы найти сами, и остаёмся на связи для каждого гостя. Качество — не обещание: это наша повседневность.",
      role: "Президент SAS Vaucopin",
    },
    airbnb: {
      overline: "Онлайн-бронирование",
      title: "Бронируйте напрямую на Airbnb",
      sub: "Наши две студии на Airbnb: актуальные свободные даты и безопасное бронирование.",
    },
    seo: {
      home: { title: "Аренда студий Ле-7-Ло – Ле-Плене | Vaucopin", description: "Две студии у подножия трасс в Ле-Плене (Ле-7-Ло): Ô Glaciers и Ô Gentianes. Цены от 400 € за неделю. Бронирование напрямую или через Airbnb." },
      glaciers: { title: "Студия Ô Glaciers – Ле-Плене | Vaucopin", description: "Студия Ô Glaciers в Ле-Плене (5-й этаж, 28 м², 2–4 гостя): вид на Беледонн, оборудованная кухня, бесплатная парковка. От 700 € за неделю." },
      gentianes: { title: "Студия Ô Gentianes – Ле-Плене | Vaucopin", description: "Студия Ô Gentianes в Ле-Плене (1-й этаж, 26 м², 2–4 гостя): стиль шале, вид на лес, оборудованная кухня, бесплатная парковка. От 700 € за неделю." },
      contact: { title: "Запрос – Студии Ле-7-Ло | Vaucopin", description: "Отправьте запрос по студиям Ô Glaciers и Ô Gentianes в Ле-Плене. Ответ в течение 24–48 часов. Тел. +33 (0)6 42 42 42 07." },
      legal: { title: "Правовая информация | SAS Vaucopin", description: "Правовая информация сайта SAS Vaucopin: юридический адрес, SIREN 914 124 011, контакты и персональные данные (GDPR: privacy@vaucopin.com)." },
      privacy: { title: "Политика конфиденциальности | SAS Vaucopin", description: "Политика конфиденциальности сайта SAS Vaucopin: собираемые данные, цели, сроки хранения и ваши права по GDPR (контакт: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Ваш следующий отдых",
      title1: "Забронируйте отдых",
      title2a: " в Ле-7-Ло",
      contact: "Контакты",
      ourStudios: "Наши студии",
      info: "Информация",
      legal: "Правовая информация",
      contactLink: "Запрос информации",
      privacyPolicy: "Политика конфиденциальности",
    },
    studio: {
      back: "На главную",
      theStudio: "Студия",
      capacity: "Вместимость",
      surface: "Площадь",
      location: "Расположение",
      orientation: "Ориентация",
      amenitiesTitle: "Оснащение",
      gallery: "Галерея",
      pricingOverline: "Ориентировочные цены",
      pricingTitle1: "Отдых ",
      pricingTitle2a: "на любой вкус",
      pricingNote: "Ориентировочные цены, от. Для точного расчёта по вашим датам отправьте нам запрос или позвоните: {phone}.",
      season: "Сезон — цены от",
      week: "Неделя",
      weekend: "Выходные",
      ctaQuote: "Запросить цену для этой студии",
      ctaAirbnb: "Забронировать на Airbnb",
      seasons: ["Высокий сезон (зимние школьные каникулы)", "Средний сезон", "Низкий сезон / лето"],
    },
    studioData: {
      glaciers: {
        tagline: "Лицом к вершинам, залит светом",
        description: "Окна на юг, студия Ô Glaciers выходит на исключительную панораму массива Беледонн. Гостиная из светлого дерева и полностью оборудованная кухня создают уютное убежище после дня на склонах Ле-7-Ло. Вечером за большим семейным столом проходят тёплые савойские ужины.",
        capacity: "2–4 человека",
        floor: "5-й этаж, лифт",
        orientation: "На юг, вид на массив Беледонн",
        amenities: [kitchen.ru, "Семейная обеденная зона с большим столом", "Спальные места: раскладной диван + доп. места", "Телевизор с плоским экраном", "Личная лыжная ячейка у подножия трасс", "Бесплатная парковка"],
      },
      gentianes: {
        tagline: "Дух шале в самом сердце курорта",
        description: "Студия Ô Gentianes хранит подлинный дух шале: мебель с характером, цветные акценты, вдохновлённые альпийской горечавкой, и окно с видом на ели и гребни. Идеально расположенная в сердце Ле-Плене, она позволяет надеть лыжи у резиденции и за несколько шагов добраться до магазинов и ресторанов.",
        capacity: "2–4 человека",
        floor: "1-й этаж, лифт",
        orientation: "Вид на лес и вершины",
        amenities: ["Уютная обеденная зона на 4 персоны", kitchen.ru, "Спальные места: диван-кровать + горный уголок", "Телевизор с плоским экраном", "Личная лыжная ячейка у подножия трасс", "Бесплатная парковка"],
      },
    },
    contact: {
      overline: "Запрос информации",
      line1: "Расскажите нам о",
      line2a: "вашем отдыхе.",
      name: "Полное имя *",
      namePh: "Иван Иванов",
      email: "Email *",
      emailPh: "ivan@example.com",
      phone: "Телефон",
      phonePh: "+7 900 000 00 00",
      studioLabel: "Какая студия",
      both: "Обе студии",
      arrival: "Желаемая дата заезда",
      departure: "Желаемая дата выезда",
      message: "Ваше сообщение *",
      messagePh: "Здравствуйте, мы хотели бы узнать о свободных датах на...",
      submit: "Отправить запрос",
      sending: "Отправка...",
      privacyNote: "Ваши данные используются только для обработки запроса. Контакт GDPR: {privacy}",
      directTitle: "Прямой контакт",
      directNote: "Мы отвечаем на все запросы в течение 24–48 часов. Для срочного бронирования звоните нам.",
      errName: "Пожалуйста, укажите ваше имя.",
      errEmail: "Пожалуйста, укажите действительный email.",
      errMessage: "Ваше сообщение слишком короткое (минимум 10 символов).",
      success: "Ваш запрос отправлен. Мы скоро ответим.",
      error: "Произошла ошибка. Попробуйте ещё раз или позвоните нам напрямую.",
    },
  },

  uk: {
    nav: { home: "Головна", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Запит" },
    hero: {
      overline: "Vaucopin — Оренда студій — Ле-Плене, Ізер",
      line1: "Ле-7-Ло,",
      line2a: "поклик",
      line2b: " вершин.",
      intro: "Дві виняткові студії біля підніжжя трас Ле-Плене. Студія Ô Glaciers та студія Ô Gentianes чекають на вас влітку та взимку.",
      ctaStudios: "Переглянути студії",
      ctaContact: "Запит інформації",
    },
    marquee: ["Лижі біля порогу", "Панорамний вид на Беледонн", "Південна сторона", "Сімейний курорт Ле-7-Ло", "135 км трас", "Літо: походи та гірські озера"],
    studios: { overline: "Наші студії — Ле-Плене", title1: "Два притулки, ", title2a: "один стандарт", discover: "Детальніше" },
    manifesto: {
      overline: "Маніфест Vaucopin",
      chapters: [
        { title: "Враження", text: "Ле-Плене розташований на висоті 1450 метрів навпроти масиву Беледонн, зі 135 кілометрами трас, з'єднаних із Прапутелем і Піпе. Взимку лижі взувають просто біля резиденції. Влітку піші маршрути та гірські озера починаються за кілька кроків." },
        { title: "Комфорт", text: "Кожна студія задумана як притулок: натуральні матеріали, світле дерево, якісна білизна та повне оснащення. Обладнана кухня, власний лижний бокс і безкоштовна парковка — все передбачено, щоб вам лишилося одне: насолоджуватися." },
        { title: "Гостинність", text: "SAS Vaucopin — сімейна компанія. Ми знаємо курорт напам'ять і залишаємося на зв'язку до, під час та після вашого відпочинку. Питання про траси, адреса ресторану, розклад підйомників? Ми поруч." },
      ],
    },
    reviews: { overline: "Вони зупинялися в нас", title1: "Слова ", title2a: "мандрівників", sub: "Відгуки наших гостей, взимку та влітку, у Ле-Плене." },
    president: {
      overline: "Слово Президента",
      quote: "Кожна студія, яку ми здаємо, несе наше ім'я — а отже, і наші стандарти. Ми ретельно обираємо місця, обладнуємо їх так, як хотіли б знайти самі, і залишаємося на зв'язку для кожного гостя. Якість — не обіцянка: це наша буденність.",
      role: "Президент SAS Vaucopin",
    },
    airbnb: {
      overline: "Онлайн-бронювання",
      title: "Бронюйте напряму на Airbnb",
      sub: "Наші дві студії на Airbnb: актуальні вільні дати та безпечне бронювання.",
    },
    seo: {
      home: { title: "Оренда студій Ле-7-Ло – Ле-Плене | Vaucopin", description: "Дві студії біля підніжжя трас у Ле-Плене (Ле-7-Ло): Ô Glaciers та Ô Gentianes. Ціни від 400 € за тиждень. Бронювання напряму або через Airbnb." },
      glaciers: { title: "Студія Ô Glaciers – Ле-Плене | Vaucopin", description: "Студія Ô Glaciers у Ле-Плене (5-й поверх, 28 м², 2–4 гостя): вид на Беледонн, обладнана кухня, безкоштовна парковка. Від 700 € за тиждень." },
      gentianes: { title: "Студія Ô Gentianes – Ле-Плене | Vaucopin", description: "Студія Ô Gentianes у Ле-Плене (1-й поверх, 26 м², 2–4 гостя): стиль шале, вид на ліс, обладнана кухня, безкоштовна парковка. Від 700 € за тиждень." },
      contact: { title: "Запит – Студії Ле-7-Ло | Vaucopin", description: "Надішліть запит щодо студій Ô Glaciers та Ô Gentianes у Ле-Плене. Відповідь протягом 24–48 годин. Тел. +33 (0)6 42 42 42 07." },
      legal: { title: "Правова інформація | SAS Vaucopin", description: "Правова інформація сайту SAS Vaucopin: юридична адреса, SIREN 914 124 011, контакти та персональні дані (GDPR: privacy@vaucopin.com)." },
      privacy: { title: "Політика конфіденційності | SAS Vaucopin", description: "Політика конфіденційності сайту SAS Vaucopin: дані, що збираються, цілі, строки зберігання та ваші права за GDPR (контакт: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Ваш наступний відпочинок",
      title1: "Забронюйте відпочинок",
      title2a: " у Ле-7-Ло",
      contact: "Контакти",
      ourStudios: "Наші студії",
      info: "Інформація",
      legal: "Правова інформація",
      contactLink: "Запит інформації",
      privacyPolicy: "Політика конфіденційності",
    },
    studio: {
      back: "На головну",
      theStudio: "Студія",
      capacity: "Місткість",
      surface: "Площа",
      location: "Розташування",
      orientation: "Орієнтація",
      amenitiesTitle: "Оснащення",
      gallery: "Галерея",
      pricingOverline: "Орієнтовні ціни",
      pricingTitle1: "Відпочинок ",
      pricingTitle2a: "на будь-який смак",
      pricingNote: "Орієнтовні ціни, від. Для точного розрахунку за вашими датами надішліть нам запит або зателефонуйте: {phone}.",
      season: "Сезон — ціни від",
      week: "Тиждень",
      weekend: "Вихідні",
      ctaQuote: "Запросити ціну для цієї студії",
      ctaAirbnb: "Забронювати на Airbnb",
      seasons: ["Високий сезон (зимові шкільні канікули)", "Середній сезон", "Низький сезон / літо"],
    },
    studioData: {
      glaciers: {
        tagline: "Обличчям до вершин, залита світлом",
        description: "Вікна на південь, студія Ô Glaciers відкриває виняткову панораму масиву Беледонн. Вітальня зі світлого дерева та повністю обладнана кухня створюють затишний притулок після дня на схилах Ле-7-Ло. Ввечері за великим сімейним столом проходять теплі савойські вечері.",
        capacity: "2–4 особи",
        floor: "5-й поверх, ліфт",
        orientation: "На південь, вид на масив Беледонн",
        amenities: [kitchen.uk, "Сімейна їдальня з великим столом", "Спальні місця: розкладний диван + дод. місця", "Телевізор з плоским екраном", "Власний лижний бокс біля підніжжя трас", "Безкоштовна парковка"],
      },
      gentianes: {
        tagline: "Дух шале в самому серці курорту",
        description: "Студія Ô Gentianes зберігає справжній дух шале: меблі з характером, кольорові акценти, навіяні альпійським тирличем, і вікно з видом на ялини та хребти. Ідеально розташована в серці Ле-Плене, вона дозволяє взути лижі біля резиденції та за кілька кроків дістатися магазинів і ресторанів.",
        capacity: "2–4 особи",
        floor: "1-й поверх, ліфт",
        orientation: "Вид на ліс і вершини",
        amenities: ["Затишна їдальня на 4 особи", kitchen.uk, "Спальні місця: диван-ліжко + гірський куточок", "Телевізор з плоским екраном", "Власний лижний бокс біля підніжжя трас", "Безкоштовна парковка"],
      },
    },
    contact: {
      overline: "Запит інформації",
      line1: "Розкажіть нам про",
      line2a: "ваш відпочинок.",
      name: "Повне ім'я *",
      namePh: "Іван Петренко",
      email: "Email *",
      emailPh: "ivan@example.com",
      phone: "Телефон",
      phonePh: "+380 00 000 00 00",
      studioLabel: "Яка студія",
      both: "Обидві студії",
      arrival: "Бажана дата заїзду",
      departure: "Бажана дата виїзду",
      message: "Ваше повідомлення *",
      messagePh: "Доброго дня, ми хотіли б дізнатися про вільні дати на...",
      submit: "Надіслати запит",
      sending: "Надсилання...",
      privacyNote: "Ваші дані використовуються лише для обробки запиту. Контакт GDPR: {privacy}",
      directTitle: "Прямий контакт",
      directNote: "Ми відповідаємо на всі запити протягом 24–48 годин. Для термінового бронювання телефонуйте нам.",
      errName: "Будь ласка, вкажіть ваше ім'я.",
      errEmail: "Будь ласка, вкажіть дійсний email.",
      errMessage: "Ваше повідомлення занадто коротке (мінімум 10 символів).",
      success: "Ваш запит надіслано. Ми скоро відповімо.",
      error: "Сталася помилка. Спробуйте ще раз або зателефонуйте нам напряму.",
    },
  },

  nl: {
    nav: { home: "Home", glaciers: "Ô Glaciers", gentianes: "Ô Gentianes", cta: "Aanvraag" },
    hero: {
      overline: "Vaucopin — Studioverhuur — Le Pleynet, Isère",
      line1: "Les 7 Laux,",
      line2a: "de roep",
      line2b: " van de toppen.",
      intro: "Twee uitzonderlijke studio's aan de voet van de pistes van Le Pleynet. De Studio des Ô Glaciers en de Studio des Ô Gentianes wachten op u, zomer en winter.",
      ctaStudios: "Ontdek de studio's",
      ctaContact: "Aanvraag",
    },
    marquee: ["Ski's aan de deur", "Panoramisch uitzicht op Belledonne", "Zuidligging", "Familieresort Les 7 Laux", "135 km pistes", "Zomer: wandelen & bergmeren"],
    studios: { overline: "Onze studio's — Le Pleynet", title1: "Twee toevluchtsoorden, ", title2a: "één standaard", discover: "Ontdekken" },
    manifesto: {
      overline: "Het Vaucopin-manifest",
      chapters: [
        { title: "De Ervaring", text: "Le Pleynet ligt op 1.450 meter hoogte, tegenover het Belledonne-massief, met 135 kilometer pistes verbonden met Prapoutel en Pipay. In de winter gespt u de ski's aan voor de deur van de residentie. In de zomer beginnen wandelroutes en bergmeren op een steenworp afstand." },
        { title: "Het Comfort", text: "Elke studio is ontworpen als een toevluchtsoord: natuurlijke materialen, licht hout, kwaliteitslinnen en volledige uitrusting. Uitgeruste kitchenette, privé-skikluis en gratis parkeren — alles is geregeld zodat u maar één ding hoeft te doen: genieten." },
        { title: "De Ontvangst", text: "SAS Vaucopin is een familiebedrijf. Wij kennen het resort uit het hoofd en blijven bereikbaar vóór, tijdens en na uw verblijf. Een vraag over de pistes, een restaurantadres, een liftijdstip? Wij zijn er." },
      ],
    },
    reviews: { overline: "Zij verbleven bij ons", title1: "Woorden van ", title2a: "onze gasten", sub: "Beoordelingen van onze gasten, winter en zomer, in Le Pleynet." },
    president: {
      overline: "Een woord van de President",
      quote: "Elke studio die wij verhuren draagt onze naam — en daarmee onze standaard. Wij selecteren onze locaties met zorg, rusten ze uit zoals wij ze zelf zouden willen aantreffen, en blijven bereikbaar voor elk van onze gasten. Kwaliteit is geen belofte: het is onze dagelijkse praktijk.",
      role: "Voorzitter van SAS Vaucopin",
    },
    airbnb: {
      overline: "Online boeken",
      title: "Boek direct op Airbnb",
      sub: "Vind onze twee studio's op Airbnb: realtime beschikbaarheid en veilige boeking.",
    },
    seo: {
      home: { title: "Studioverhuur Les 7 Laux – Le Pleynet | Vaucopin", description: "Twee studio's aan de piste in Le Pleynet (Les 7 Laux): Studio des Ô Glaciers en Ô Gentianes. Weekprijzen vanaf €400. Direct of via Airbnb." },
      glaciers: { title: "Studio des Ô Glaciers – Le Pleynet | Vaucopin", description: "Studio des Ô Glaciers in Le Pleynet (5e verdieping, 28 m², 2–4 pers.): uitzicht op Belledonne, uitgeruste kitchenette, gratis parkeren. Vanaf €700/week." },
      gentianes: { title: "Studio des Ô Gentianes – Le Pleynet | Vaucopin", description: "Studio des Ô Gentianes in Le Pleynet (1e verdieping, 26 m², 2–4 pers.): chaletstijl, boszicht, uitgeruste kitchenette, gratis parkeren. Vanaf €700/week." },
      contact: { title: "Aanvraag – Studio's Les 7 Laux | Vaucopin", description: "Stuur uw aanvraag voor de studio's Ô Glaciers en Ô Gentianes in Le Pleynet. Antwoord binnen 24–48 uur. Tel. +33 (0)6 42 42 42 07." },
      legal: { title: "Juridische vermeldingen | SAS Vaucopin", description: "Juridische vermeldingen van de SAS Vaucopin-website: maatschappelijke zetel, SIREN 914 124 011, contact en persoonsgegevens (GDPR: privacy@vaucopin.com)." },
      privacy: { title: "Privacybeleid | SAS Vaucopin", description: "Privacybeleid van de SAS Vaucopin-website: verzamelde gegevens, doeleinden, bewaartermijnen en uw GDPR-rechten (contact: privacy@vaucopin.com)." },
    },
    footer: {
      nextStay: "Uw volgende verblijf",
      title1: "Boek uw ontsnapping",
      title2a: " naar Les 7 Laux",
      contact: "Contact",
      ourStudios: "Onze studio's",
      info: "Informatie",
      legal: "Juridische vermeldingen",
      contactLink: "Aanvraag",
      privacyPolicy: "Privacybeleid",
    },
    studio: {
      back: "Terug naar home",
      theStudio: "De studio",
      capacity: "Capaciteit",
      surface: "Oppervlakte",
      location: "Ligging",
      orientation: "Oriëntatie",
      amenitiesTitle: "Uitrusting",
      gallery: "Galerij",
      pricingOverline: "Indicatieve tarieven",
      pricingTitle1: "Verblijven ",
      pricingTitle2a: "op maat",
      pricingNote: "Indicatieve tarieven, vanaf. Voor een exacte prijsopgave voor uw data stuurt u ons een aanvraag of belt u ons op {phone}.",
      season: "Seizoen — prijzen vanaf",
      week: "Week",
      weekend: "Weekend",
      ctaQuote: "Vraag een offerte voor deze studio",
      ctaAirbnb: "Boeken op Airbnb",
      seasons: ["Hoogseizoen (winter schoolvakanties)", "Middenseizoen", "Laagseizoen / zomer"],
    },
    studioData: {
      glaciers: {
        tagline: "Naar de toppen gericht, baadt in het licht",
        description: "De Studio des Ô Glaciers, op het zuiden georiënteerd, opent zich op een uitzonderlijk panorama van de Belledonne-keten. De woonruimte van licht hout en de volledig uitgeruste kitchenette vormen een knus toevluchtsoord na een dag op de pistes van Les 7 Laux. 's Avonds nodigt de grote familietafel uit voor Savoyaardse diners in een warme sfeer.",
        capacity: "2 tot 4 personen",
        floor: "5e verdieping met lift",
        orientation: "Zuid, uitzicht op de Belledonne-keten",
        amenities: [kitchen.nl, "Familie-eethoek met grote tafel", "Slaapplaatsen: slaapbank + extra bedden", "Flatscreen-tv", "Privé-skikluis aan de voet van de pistes", "Gratis parkeren"],
      },
      gentianes: {
        tagline: "Chaletsfeer in het hart van het resort",
        description: "De Studio des Ô Gentianes ademt de authentieke chaletsfeer: meubels met karakter, kleuraccenten geïnspireerd op de alpen-gentianen en een raam met uitzicht op sparren en bergkammen. Ideaal gelegen in het hart van Le Pleynet: u gespt de ski's aan voor de deur van de residentie en bereikt winkels en restaurants in een paar stappen.",
        capacity: "2 tot 4 personen",
        floor: "1e verdieping met lift",
        orientation: "Uitzicht op bos en toppen",
        amenities: ["Gezellige eethoek voor 4 personen", kitchen.nl, "Slaapplaatsen: slaapbank + bergstapelbedden", "Flatscreen-tv", "Privé-skikluis aan de voet van de pistes", "Gratis parkeren"],
      },
    },
    contact: {
      overline: "Aanvraag",
      line1: "Vertel ons over",
      line2a: "uw verblijf.",
      name: "Volledige naam *",
      namePh: "Jan Jansen",
      email: "E-mail *",
      emailPh: "jan@voorbeeld.nl",
      phone: "Telefoon",
      phonePh: "+31 6 00000000",
      studioLabel: "Betreffende studio",
      both: "Beide studio's",
      arrival: "Gewenste aankomstdatum",
      departure: "Gewenste vertrekdatum",
      message: "Uw bericht *",
      messagePh: "Goedendag, wij willen graag de beschikbaarheid weten voor...",
      submit: "Verstuur mijn aanvraag",
      sending: "Verzenden...",
      privacyNote: "Uw gegevens worden alleen gebruikt om uw aanvraag te verwerken. GDPR-contact: {privacy}",
      directTitle: "Direct contact",
      directNote: "Wij beantwoorden alle aanvragen binnen 24 tot 48 uur. Voor last-minute boekingen belt u ons.",
      errName: "Vul uw naam in.",
      errEmail: "Vul een geldig e-mailadres in.",
      errMessage: "Uw bericht is wat kort (minimaal 10 tekens).",
      success: "Uw aanvraag is verzonden. Wij antwoorden u snel.",
      error: "Er is een fout opgetreden. Probeer het opnieuw of bel ons direct.",
    },
  },
};
